import classNames from 'classnames'
import { FunctionalComponent } from 'preact'
import { z } from 'zod'
import DateRelative from '../../libs/translationsUtils/dateRelative'
import { Author } from '../../services/unified'
import EventDateFormatter from '../Event/EventDateFormatter'
import UserAvatar from '../User/UserAvatar'

interface TopicBannerData {
  author: Author | null
  post?: {
    author: {
      id: number
      url: string
      name: string
      avatar: string
      rank: null
    }
    relativeCreationDate: string
  }
  createdAt?: string
  startsAt?: number
  publishedAt?: string
  url: string
  title: string
}

interface Props {
  selectedTopic: TopicBannerData | null
}

export const widgetName = 'topic_banner'

export const config = z
  .object({
    selectedTopic: z
      .object({
        id: z.string(),
        type: z.string()
      })
      .or(z.null())
      .default(null)
  })
  .default({
    selectedTopic: null
  })

const TopicBanner: FunctionalComponent<Props> = ({ selectedTopic }: Props) => {
  if (!selectedTopic) {
    return null
  }

  const author = selectedTopic.author || selectedTopic.post?.author
  const date = selectedTopic.publishedAt || selectedTopic.createdAt

  return (
    <div className='topic-banner_wrapper featuredBanner'>
      <a className='banner-notification_url' href={selectedTopic.url} />
      <div className={classNames('box', 'banner-notification', 'notification')}>
        <div className='box__content box__pad'>
          <p className='notification-title'>
            <span className='notification-link'>
              {selectedTopic.title.length > 100 ? selectedTopic.title.substring(0, 100) + '...' : selectedTopic.title}
            </span>
          </p>
          {selectedTopic.startsAt ? (
            <span className='thread-meta-item__date notification-link'>
              ({EventDateFormatter.formatStartAtForOverviewList(selectedTopic.startsAt)})
            </span>
          ) : (
            <span className='thread-meta-item'>
              {author !== undefined && <UserAvatar user={author} extraClass='avatar avatar--S' showRank />}
              <span className='notification-link'>
                <span className='thread-meta-item__date'>
                  {date ? (
                    <DateRelative dateTime={new Date(date).getTime()} />
                  ) : (
                    selectedTopic.post?.relativeCreationDate || ''
                  )}
                </span>
              </span>
            </span>
          )}
        </div>
      </div>
    </div>
  )
}

export default TopicBanner
